<script setup lang="ts">
/**
 * Los ajustes se repartieron en `/settings/*` (una página por sección) cuando
 * Account dejó de ser una pantalla con tabs. Esta ruta queda solo para no
 * romper enlaces guardados o pestañas abiertas de la versión anterior.
 */
definePage({
  meta: { requiresAuth: true },
  redirect: { name: 'settings' },
});
</script>

<template>
  <div />
</template>
